import React from 'react';

const Header = () => {
  return (
    <>
      <div className='sticky flex items-center top-0 bg-white border-b border-slate-200 h-16 z-40'>
        <div className='flex justify-between items-center w-full lg:w-2/5 xl:w-2/3 lg:mx-auto px-8 lg:px-0'>
          <div className='flex items-center '>
            <img src='/logo.svg' width={50} height={50} />
            <h1 className='text-2xl font-semibold ml-3 uppercase text-[#058ff4]'>Sierra Documents Center</h1>
          </div>
          <div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Header;